export const properties = {
  apiWebClient: 'web-provart-ml-conexia',
  apiWebClientPassword: '$2y$12$js/tUl6hMV.JJJxiWJm2LuGY8nInU0XobR81nWJPd2PKD/9Xteh3e',
};
